<template>

    <div class="card mb-3">
        <div class="row g-0">
            <div class="col-md-4">
                <img :src="kitchen.image" class="img-fluid rounded-start" alt="...">
                <input type="file" :key="inputKey" @change="handleFileUpload($event, kitchen.id)" />
            </div>
            <div class="col-md-8">
                <div class="card-body">
                    <h5 class="card-title">{{ kitchen.name }}</h5>
                    <p class="card-text">{{ kitchen.description }}</p>
                </div>
                <div class="d-flex justify-content-end">
                    <div>
                        <modal-slot buttonName="Add a dish">
                            <template #default="{ closeModal }">
                                <CreateDish :closeModal = "closeModal"></CreateDish>
                            </template>
                            
                        </modal-slot>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        
            <div class="row justify-content-center">
                <div class="col-md-10">
                    <DishList />
                </div>
            </div>

    </div>

</template>

<script setup>

import DishList from "./DishList.vue";

import ModalSlot from '../utils/ModalSlot.vue';

import CreateDish from './CreateDish.vue'
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useKitchenStore } from "@/stores/kitchen";

import api from "@/services/api";

import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const inputKey = ref(Date.now());


const kitchen = computed(()=>{
   return  store.kitchens.find((el) => {
        if(el.id == route.params.id){
            return el;
        }
    });
} );

const route = useRoute();

const store = useKitchenStore();

async function handleFileUpload(event, id){

const formData = new FormData();
formData.append('image', event.target.files[0]);

try {
const kitchen =  await api.post('user/admin/upload/kitchen/'+id, formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

store.addKitchen(kitchen.data);
toast("Image uploaded!", {
    autoClose: 1000,
  });


  inputKey.value = Date.now();

} catch (error) {
inputKey.value = Date.now();
alert('Image upload failed.');
}

}
</script>